// Mock data for global categories and subcategories

import type { GlobalCategory, GlobalSubcategory, CategoryStats } from '@/types/category.types';

// ============================================================================
// GLOBAL CATEGORIES
// ============================================================================

export const mockGlobalCategories: GlobalCategory[] = [
  {
    id: 1,
    name: 'Labour',
    code: 'CAT-001',
    type: 'labour',
    description: 'Labour costs including salaries, wages, and contractor fees',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 45,
  },
  {
    id: 2,
    name: 'Materials',
    code: 'CAT-002',
    type: 'expenses',
    description: 'Raw materials and supplies required for project delivery',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 38,
  },
  {
    id: 3,
    name: 'Equipment',
    code: 'CAT-003',
    type: 'expenses',
    description: 'Equipment purchases, rentals, and maintenance',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 32,
  },
  {
    id: 4,
    name: 'Subcontractors',
    code: 'CAT-004',
    type: 'subcontractors',
    description: 'External contractors and subcontractor services',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 28,
  },
  {
    id: 5,
    name: 'Travel & Expenses',
    code: 'CAT-005',
    type: 'expenses',
    description: 'Travel, accommodation, meals, and other business expenses',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 35,
  },
  {
    id: 6,
    name: 'Software & Licenses',
    code: 'CAT-006',
    type: 'expenses',
    description: 'Software licenses, subscriptions, and digital tools',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 40,
  },
  {
    id: 7,
    name: 'Overhead',
    code: 'CAT-007',
    type: 'overhead',
    description: 'Indirect costs and overhead allocation',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 25,
  },
  {
    id: 8,
    name: 'Contingency',
    code: 'CAT-008',
    type: 'contingency',
    description: 'Contingency budget for unforeseen costs and risks',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 20,
  },
];

// ============================================================================
// GLOBAL SUBCATEGORIES
// ============================================================================

// Subcategories removed - using flat structure
export const mockGlobalSubcategories: GlobalSubcategory[] = [];

// ============================================================================
// CATEGORY STATS
// ============================================================================

export const mockCategoryStats: CategoryStats = {
  totalGlobal: mockGlobalCategories.length,
  totalProjectSpecific: 0, // Will be calculated per project
  totalActive: mockGlobalCategories.filter(c => c.status === 'active').length,
  totalArchived: mockGlobalCategories.filter(c => c.status === 'archived').length,
  mostUsedCategories: [
    { id: 1, name: 'Labour', usageCount: 45 },
    { id: 6, name: 'Software & Licenses', usageCount: 40 },
    { id: 2, name: 'Materials', usageCount: 38 },
    { id: 5, name: 'Travel & Expenses', usageCount: 35 },
    { id: 3, name: 'Equipment', usageCount: 32 },
  ],
};

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================

export function getGlobalCategoryById(id: number): GlobalCategory | undefined {
  return mockGlobalCategories.find(c => c.id === id);
}

export function getGlobalSubcategoriesByCategory(categoryId: number): GlobalSubcategory[] {
  return mockGlobalSubcategories.filter(s => s.categoryId === categoryId);
}

export function getGlobalCategoriesByType(type: string): GlobalCategory[] {
  return mockGlobalCategories.filter(c => c.type === type && c.status === 'active');
}

export function getDefaultGlobalCategories(): GlobalCategory[] {
  return mockGlobalCategories.filter(c => c.isDefault && c.status === 'active');
}

export function getDefaultGlobalSubcategories(): GlobalSubcategory[] {
  return mockGlobalSubcategories.filter(s => s.isDefault && s.status === 'active');
}
